import withUserInfo from './withUserInfo';
export default withUserInfo;
